import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const LVIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="LV" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 7.2h16V12H0V7.2Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 4h16v3H0V4Z"
        clipRule="evenodd"
      />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0h16v4.8H0V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
